/**
 * @fileoverview Error for a list that has more rows than the page-by-page reader will fetch.
 * @description Thrown instead of silently returning the first rows, so a table or dropdown never
 * looks complete when it is not. The screens show their "narrow the filters" message for it.
 * @copyright Copyright (c) 2026 Brownbox Consulting. All rights reserved.
 * @author Anshul Rokde
 */

/** @description A list matched more rows than can be fetched at once. */
export class ResultCapExceededError extends Error {
  readonly cap: number

  /**
   * @description Builds the error for a list capped at a number of rows.
   * @param {number} cap - The most rows that are fetched.
   */
  constructor(cap: number) {
    super(`More than ${cap} rows match; narrow the filters.`)
    this.name = 'ResultCapExceededError'
    this.cap = cap
  }
}

/**
 * @description Whether an error is the list-too-long refusal.
 * @param {unknown} error - A query's error.
 * @returns {boolean} True for a ResultCapExceededError.
 */
export function isResultCapExceeded(error: unknown): boolean {
  return error instanceof ResultCapExceededError
}
